import { navigationMenuMobileSonicsmooth } from './pages/navigation-menu-mobile'
import { swiperHowToUseSonnicsmooth } from './test/how-to-use-sonnicsmooth';

document.addEventListener('DOMContentLoaded', () => {
  console.log('Hello World Pages!');
  navigationMenuMobileSonicsmooth();
  swiperHowToUseSonnicsmooth();
});
